import {Injectable} from '@angular/core';
import {HttpObservable} from '../../http/services/http.wrapper';
import {TranslateLanguage} from '../interfaces/translate.language';
import {APIProxy} from "../../http/services/api.proxy";

/**
	* ***************************************************************
	* The proxy used for server communication for translation.
	*
	* Written by: Dana Moshe
	* ***************************************************************
	*/
@Injectable()
export class TranslateProxy {

	constructor(private apiHttp:APIProxy) {
	}

	public getTranslation(lang:string):HttpObservable<Object> {
		return this.apiHttp.getAnon("Translate", "GetTranslation", {pName: "lang", pVal: lang});
	}

	public getTranslationAndLang(langCode:string):HttpObservable<{languageData:TranslateLanguage;translations:Object}> {
		return this.apiHttp.getAnon("Translate", "GetTranslationAndLang", {pName: "langCode", pVal: langCode});
	}

	public getLanguages():HttpObservable<TranslateLanguage[]> {
		return this.apiHttp.getAnon("Translate", "GetLanguages");
	}

	public getUserLanguage():HttpObservable<any> {
		return this.apiHttp.get("UserContext", "GetUserLanguage");
	}
}
